import React from 'react'
import { Radio, RadioGroup, LabeledInput } from '@apex/component-library'
import { Stack, Text } from '@chakra-ui/react'
import { BeneficiaryTypes } from '../../containers/WireTransfers/Types'
import { FormikErrors, FormikTouched } from 'formik'

interface errors {
  fromAccount: string
  transferAmountDisplay: string
  transferAmountRaw: number
  totalBalanceCheckbox: boolean
  beneficiaryType: BeneficiaryTypes
  beneficiaryName: string
  beneficiaryAccountNumOrIBAN: string
}

interface FormikTouchedValues {
  beneficiaryName: boolean
  beneficiaryAccountNumOrIBAN: boolean
}
interface Props {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  selectedType: BeneficiaryTypes
  accountName: string
  name: string
  accountNum: string
  errors?: FormikErrors<errors>
  formikTouched: FormikTouched<FormikTouchedValues>
  formikBlur: (e: React.FocusEvent<any>) => void
}

export const WireSelectBeneficiary = ({
  setFieldValue,
  selectedType,
  accountName,
  name,
  accountNum,
  errors,
  formikTouched,
  formikBlur
}: Props) => {
  const handleTypeChange = (value: string) => {
    setFieldValue('beneficiaryType', value)
  }

  return (
    <>
      <Text as='h3' textStyle='h3'>
        Beneficiary
      </Text>
      <RadioGroup onChange={handleTypeChange} value={selectedType}>
        <Radio value={BeneficiaryTypes.AccountHolder} display='inline' width='9em'>
          Account Holder
        </Radio>
        <Radio value={BeneficiaryTypes.ThirdParty} display='inline' data-testid='thirdParty' width='8em'>
          Third-party
        </Radio>
      </RadioGroup>
      <Stack direction='row' spacing={8} width='100%'>
        <LabeledInput
          label='Beneficiary Name'
          name='beneficiaryName'
          isReadOnly={selectedType === BeneficiaryTypes.AccountHolder}
          isRequired
          value={selectedType === BeneficiaryTypes.AccountHolder ? accountName : name}
          data-test-handle='beneficiary-input'
          onChange={(e) => {
            setFieldValue('beneficiaryName', e.target.value)
          }}
          onBlur={formikBlur}
          isInvalid={formikTouched.beneficiaryName && !!errors?.beneficiaryName}
          errorMessage={errors?.beneficiaryName}
        />
        <LabeledInput
          label='Account # or IBAN'
          name='beneficiaryAccountNumOrIBAN'
          data-test-handle='account-num'
          isRequired
          value={accountNum}
          onChange={(e) => {
            setFieldValue('beneficiaryAccountNumOrIBAN', e.target.value)
          }}
          onBlur={formikBlur}
          isInvalid={formikTouched.beneficiaryAccountNumOrIBAN && !!errors?.beneficiaryAccountNumOrIBAN}
          errorMessage={errors?.beneficiaryAccountNumOrIBAN}
        />
      </Stack>
    </>
  )
}
